import type { User } from '../types';

export const isAccountDisabled = (
  user: Pick<User, 'accountStatus' | 'isActive'> | null | undefined
): boolean =>
  Boolean(
    user &&
      (user.isActive === false ||
        user.accountStatus === 'suspended' ||
        user.accountStatus === 'terminated' ||
        user.accountStatus === 'deleted')
  );

export const isSystemManager = (
  user: Pick<User, 'role' | 'adminScope' | 'accountStatus' | 'isActive'> | null | undefined
): boolean =>
  Boolean(
    user &&
      user.role === 'admin' &&
      user.adminScope === 'system_manager' &&
      !isAccountDisabled(user)
  );
